export const constants = {
  NO_INTERNET_CONNECTION_MSG: "No Internet Connection",
  ROLE: {
    AGENT: "agent",
    USER: "user",
  },
  BUSINESS_CATEGORIES: [{ value: "Individual" }, { value: "Corporate" }],
  BUSINESS_CATEGORIES_INDIVIDULES: "Individual",
  BUSINESS_CATEGORIES_CORPORATE: "Corporate",
  LOCALSTORAGE_DB_KEY_NAME: "PWA-Angular-STARTER",
  MOBILE_NUMBER: "Mobile Number",
  EMAIL: "Email Address",
  OTP_FROM: {
    SIGN_UP_MOBILE: "signUpMobile",
    SIGN_UP_EMAIL: "signUpEmail",
    FORGOT_PASSWORD_MOBILE: "forgotPasswordMobile",
    FORGOT_PASSWORD_EMAIL: "forgotPasswordEmail",
  },
  X_TEXT: "xxxx  ",
  PAYMENT_TYPES: {
    CRAD: "card",
    BANK: "bank",
  },
  RESEND_OTP_TIME: 120,
  AGENT_DOCUMENT_REQUIRED: {
    INDIVIDUAL: {
      ID_CARD: "ID Card",
      BANK_STATMENT: "Bank Statement",
    },
    CORPORATE: {
      CAC_CERTIFICATE: "CAC Certificate",
      CAC_FROM_A: "CAC Form A",
      UTILITY_BILL: "Utility Bill",
      MEANS_OF_IDENITIFICATION: "Means of Identification for one director",
    },
  },
  AGENT_DOCUMENT_DATA: {
    INDIVIDUAL: [
      { value: "ID Card", fromControlName: "idCard" },
      { value: "Bank Statement", fromControlName: "BankStatment" },
    ],
    CORPORATE: [
      { value: "CAC Certificate", fromControlName: "cacCertificate" },
      { value: "CAC Form A", fromControlName: "cacFromA" },
      { value: "Utility Bill", fromControlName: "utilityBill" },
      {
        value: "Means of Identification for one director",
        fromControlName: "meansOfIdenitification",
      },
    ],
  },
  FILE_UPLOAD_SIZE_LIMIT: 10000000,
  KYC_STATUS: {
    VERIFIED: "Verified",
    NOT_VERIFIED: "NotVerified",
  },
  WALLET_SETUP_TYPE: {
    BANK: "bank",
    CARD: "card",
  },
  DOCUMENT_UPLOAD_FILE_EXTENSION: ".pdf,.jpg,.jpeg, .png",
  SET_KYC: "setKyc",
  GET_IP: "https://api.ipify.org/?format=json",
};

export const KYC_STATUS = {
  VERIFIED: "Verified",
  UNVERIFIED: "NotVerified",
};

export const PROFILE_CONTROLS = {
  FIRSTNAME: "firstName",
  LASTNAME: "lastName",
  EMAIL: "email",
  MOBILE: "mobile",
};

export const LOCAL_STORAGE_KEYS = {
  TOKEN: "token",
  DATAOFBIRTH: "dateOfBirth",
  FIRSTNAME: "firstname",
  LASTNAME: "lastname",
  PROFILE: "profile",
  ADDRESS: "address",
  COUNTRY: "country",
  REGION: "region",
  CITY: "city",
  ADDRESSMORE: "addressMore",
  CURRENCY_NAME: "currencyName",
  CURRENCY_SYMBOL: "currencySymbol",
  PROFILE_IMAGE: "profileImage",
  ID: "id",
  ROLE: "role",
  MOBILE: "mobile",
  MOBILECOUNTRYCODE: "mobileCountryCode",
  BUSINESS_CATEGORIES: "businessCategories",
  KYC_STATUS: "kycStatus",
  EMAIL: "email",
  DEVICE_ID: "deviceId",
  USER_TYPE: "USER",
  IS_TRANSACTION_PIN: "isTransactionPin",
  QR_CODE: "qrCode",
  BUSINESS_NAME: "businessName",
  SKIP_KYC: "skipKyc",
  WALLET_BALNCE: "wallet-balance",
  SEND_REQUEST_USERDATA: "send-request-userdata",
  FCM_TOKEN: "fcm-token",
};

export const USER_ROUTES = {
  SIGN_UP: "user/sign-up",
  VERIFY_OTP: "user/verify-otp",
  RESEND_OTP: "user/resend-otp",
  SIGN_IN: "auth/login",
  FORGOT_PASSWORD: "user/send-email-otp",
  VERIFY_AUTH_EMAIL_OTP: "user/verify-email-otp",
  VERIFY_PASSWORD_LINK: "user/reset-password?",
  RESET_PASSWORD: "user/reset-password",
  SAVE_PHONE: "user/send-phone-otp-for-update",
  ADDERESS_UPDATE: "user/save-details",
  SEND_EMAILOTP_UPDATE: "user/send-email-otp-for-update",
  RESET_CONFIRM_PASSWORD: "user/edit-password",
  VERIFY_EMAIL: "user/verify-email?uniqueCode=",
  VERIFY_EMAIL_OTP: "user/verify-email-otp-for-update",
  VERIFY_PHONE_OTP: "user/verify-phone-otp-for-update",
  CHANGE_PASSWORD: "user/change-password",
  CHANGE_EXPLOREPIN: "user/change-explorepin",
  UPLOAD_DOCUMENT: "user/upload-document",
  SET_TRANSACTION_PIN: "user/transaction-pin",
  RESEND_EMAIL_LINK: "user/resend-link",
  KYC_SUBMIT: "user/kyc-verification",
  SET_WALLET: "user/bank-account",
  KEY_VERIFICATION: "user/kyc-verification",
  PROFILE: "user/profile",
  UPLOAD_IMAGE: "user/profile-picture",
};

export const MERCHANT_ROUTES = {
  PROFILE: "merchant/profile",
  STAFF_MEMBERS: "merchant/staff-member",
  CHECKOUTS: "merchant/checkout",
  SEND_DOCUMENT_REQUEST_EMAIL: "merchant/complete-registration-email",
};

export const FOOD_ROUTES = {
  PROFILE: "cook/restaurant-profle",
};

export const COUNTRY = {
  COUNTRY: "common/country",
  COUNTRY_FLAG: "common/country/flag",
};

export const CARDS = {
  GET_CARDS: "payment/card",
  SET_DEFAULT_CARD: "payment/card",
  ADD_CARD: "payment/card",
  DELETE_CARD: "payment/card",
};

export const BANKS = {
  GET_BANKS_LIST: "payment/bank",
  GET_BANKS: "payment/user-bank/user_banks",
  ADD_BANKS: "payment/user-bank/create-bank-detail",
  SEND_ADD_BANKS_OTP: "payment/user-bank/send-create-user-bank-otp",
  SET_DEFAULT_BANK: "payment/user-bank/update-bank-primary-status",
  DELETE_BANK: "payment/user-bank/delete-bank",
  UPDATE_BANK: "payment/user-bank/edit-bank",
};
export const BANNER_ = {
  GET_BANNER:
    "admin/banner/user/banner?bannerUserHomePage=true&bannerUserPayPage=false&bannerMerchantHomePage=false",
  POST_CLICK: "admin/banner/user/click",
  POST_BANNER_CLOSE: "admin/banner/user/close",
};
export const REWARDS = {
  GET_CURRENT: "user/reward-misc-details",
  GET_RETAILERS_LIST: "reward/prize-pool/all/19?page=1&limit=10",
  POST_REDEEM_POINTS: "user/redeem-points",
  GET_EARNED_LIST: "user/reward-history",
  GET_REDEEMED_LIST: "user/reward-history",
};

export const OTP_TYPES = {
  SIGN_UP_MOBILE: "signUpMobile",
  SIGN_UP_EMAIL: "signUpEmail",
  FORGOT_PASSWORD_MOBILE: "forgotPasswordMobile",
  FORGOT_PASSWORD_EMAIL: "forgotPasswordEmail",
};

export const AGENT_MERCHANT_CATEGORY = [
  {
    INDIVIDUAL: "Individual",
    CORPORATE: "Corporate",
  },
];

export const TRANSACTION_PIN_CONFIG = {
  PIN_LENGTH: 6,
  PIN_CLASSES: "pin-input-control d-inline",
  PIN_AUTO_FOCUS: true,
  IS_PASSWORD_INPUT: true,
  ALLOW_ONLY_NUMBERS: true,
};

export const PIN_TYPE = {
  OLD_PIN: "oldPin",
  NEW_PIN: "newPin",
  CONFIRM_PIN: "confirmPin",
};

export const ROUTE_PATHS = {
  HOME: "home",
  RESET_PASSWORD: "reset-password/:uniqueCode",
  VERIFY_PASSWORD: "verify-email/:uniqueCode",
  WALLET_SETUP: "wallet-setup",
  MY_WALLET: "my-wallet",
  PROFILE: "profile",
  ADD_MONEY_BANK: "add-money-bank",
  TRANSFER_MONEY: "transfer-money",
  WITHDRAW_MONEY: "transfer-withdraw-money",
  PRIVACY_POLICY: "privacy-policy",
  TERMS_AND_CONDITION: "terms-and-condition",
  LOGIN: "login",
  FORGOT_PASSWORD: "forgot-password",
  EXPLORE_PIN: "explore-pin",
  EMAIL_VERIFICATION: "email-verify",
  PHONE_VERIFICATION: "phone-verify",
  RESET_CONFIRM_PASSWORD: "reset-password",
  SETTINGS: "settings",
  TRANSACTIONS: "transactions",
  TRANSACTIONS_LIST: "transactions-list",
  TEMPLATELIST: "template-list",
  DASHBOARD: "home/dashboard",

  SETTING_GENERAL: "general",
  SETTING_PAYMENT: "payment",
  SETTING_FOOD: "food",

  FOOD_ORDER_OVERVIEW: "overview",
  FOOD_ORDER_HISTORY: "history",
  FOOD_ORDER_ITEM_AVAILABILITY: "item-availability",
  FOOD_ORDER_REVIEW: "review",
  FOOD_OVERVIEW: "overview",
  FOOD_MENU: "menu",
  FOOD_CATS: "categories",
  FOOD_ITEMS: "items",
  FOOD_CUSTOMISATIONS: "customisations",
  FOOD_ADD_MENU: "add-or-update-menu",
  FOOD_ADD_UPDATE_MENU_ITEM: "add-or-update-menu-item",
  FOOD_ADD_CATEGORY: "add-or-update-cat",
  ADD_CREDIT_CARD: "add-credit-card",
  ADD_DEBIT_CARD: "add-debit-card",
  ADD_BANK: "add-bank",
  ADD_BANK_EXPLORE_PIN: "add-bank-explore-pin",
  CHANGE_PASSWORD: "change-password",
  CHANGE_EXPLORE_PIN: "change-smart-pay-pin",
  BILL_PAY: "bill-pay",

  NOTIFICATION: "notification",
  NOTIFICATION_CHATS: "chats",
  NOTIFICATION_CHATS_DETAIL: "chat-detail",
  NOTIFICATION_LIST: "notification-list",

  ADD_MONEY: "add-money",
  SEND_OR_REQUEST_MONEY: "send-request-money",
  SECURE_PAYMENTS: "secure-payments",
  TOP_UP: "top-up",
  SUCCESS: "success",
  ADD_MONEY_DEBIT_OR_CREDIT: "add-money/debit-or-credit",
  REQUEST_FROM_FRIEND: "add-money/request-from-friend",
  EXPLORE_MERCHAND: "add-money/smartie-merchant",
  EXPLORE_DRIVER: "add-money/explore-driver",
  BANK_TRANSFER_OR_DEPOSIT: "add-money/bank-transfer-info",
  TRANSFER_TO_BANK: "add-money/bank-transfer",

  PAYROLL: "payroll",
  PAYROLL_CREATE_TEMPLATE: "pr-create-template",
  PAYROLL_INPUT_TEMPLATE: "pr-input-template",
  PAYROLL_PAY_ALL_EXPLORE_PIN: "pr-pay-all-explore-pin",

  SCHEDULE_TEMPLATE_LIST: "schedule-template-list",
  SCHEDULE_TEMPLATE_CREATE_TEMPLATE: "schedule-create-template",
  SCHEDULE_TEMPLATE_INPUT_TEMPLATE: "schedule-input-template",

  HELP: "help",
  SUB_HELP: "sub-help",
  HELP_DETAIL: "detail",
  HELP_SUPPORT_TICKET: "support-ticket",
  HELP_TICKET_CHAT: "support-chat",
  HELP_NEW_TICKET: "create-ticket",

  ANALYTICS: "analytics",
  REWARDS: "rewards",
  MY_REWARDS: "my-rewards",
};

export const PROFILE_ROUTE = {
  PROFILE_HOME: "profile",
  EDIT_PROFILE: "edit-profile",
  CHANGE_PASSWORD: "change-password",
  TRANSACTION_PIN: "transation-pin",
  MY_TRANSACTION: "my-transation",
  ACCOUNT_SETTING: "account-setting",
  PAYMENT_SETTING: "payment-setting",
  ADD_MONEY_DASHBOARD: "add-money",
  MY_DOCUMETS: "my-documents",
  MY_COMMISSIONS: "my-commissions",
};

export const AFTER_PIN_SUCCESS = {
  ADD_MONEY_WALLET: "add-money-wallet",
  SEND_MONEY_WALLET: "send-money-wallet",
  SEND_MONEY_CARD: "send-money-card",
  REQUEST_MONEY: "request-money",
  TRANSFER_TO_BANK: "transfer-to-bank",
  TOP_UP: "Top-up",
  REFUND: "Refund",
  PAYROLLTOALL: "payrollPayToAll",
  PAYROLLTOMULTIPLE: "payrollPayToMultiple",
  UPDATE_EMAIL: "UPDATE_EMAIL",
  SEND_MONEY_WALLET_TEMPLATE: "send-money-wallet-template",
};

export const CHART_MONTH_LABELS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "July",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const CHART_WEEKDAY_LABELS = [
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
  "Sun",
];
